import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { PageStateFlags } from 'src/app/constants/page-state.constants';
import { LearningPathOverviewModel } from 'src/app/models/learning-paths/learning-path-overview.model';
import { LearningPathModel } from 'src/app/models/learning-paths/learning-path.model';
import { TableColumn } from 'src/app/models/table-column.model';
import { LearningPathService } from 'src/app/services/learning-path.service';
import { LoadingService } from 'src/app/services/loading.service';
import { PageStateService } from 'src/app/services/page-state.service';

@Component({
  selector: 'app-manage-learning-path-overview',
  standalone: false,
  templateUrl: './manage-learning-path-overview.component.html',
  styleUrl: './manage-learning-path-overview.component.scss',
})
export class ManageLearningPathOverviewComponent {
  learningPaths: LearningPathOverviewModel[] = [];
  
  learningPathColumns: TableColumn[] = [
    {
      caption: this.translateService.instant('COMMON.FIELDS.NAME'),
      dataField: 'name',
      cssClass: 'width-250',
    },
    {
      caption: this.translateService.instant('COMMON.PERSONS'),
      dataField: 'personsCount',
      dataType: 'number',
    },
     {
      caption: this.translateService.instant('COMMON.COMPLETION') + ' %',
      dataField: 'completionPercentage',
      dataType: 'number',
      name: 'completionPercentage',
      calculateDisplayValue: (data: LearningPathOverviewModel): string => {
        return `${data.completionPercentage} %`;
      },
      calculateSortValue: (data: LearningPathOverviewModel): number => {
        return data.completionPercentage;
      },
    },
    {
      caption: '',
      dataField: 'completionPercentage',
      dataType: 'string',
      name: 'completionPercentage',
      cellTemplate: 'progressBullet',
      disableFiltering: true,
    },
    {
      caption: '',
      dataField: 'this',
      cellType: 'action',
      disableFiltering: true,
      cellTemplate: 'actionsTemplate',
      cssClass: 'width-eq-70',
      actions: [
        {
          icon: 'link-tab',
          isShowAction: () => true,
          onClick: (leariningPath: LearningPathModel, e: any): void => {
            e.stopPropagation();
            e.preventDefault(); 
            e.stopImmediatePropagation();
            this.learningPathNavigateHandlerNewTab(leariningPath.id);
          },
        },
      ],
    },
  ];

  readonly learningPathsStateKey: string = 'learning-paths-overview';

  constructor(
    private loadingService: LoadingService,
    private learningPathService: LearningPathService,
    private router: Router,
    private translateService: TranslateService,
    private pageStateService: PageStateService
  ) {
    
  }

  ngOnInit(): void {
    if (!this.pageStateService.consumeFlag(
      PageStateFlags.RestoreLearningPathsOverview
    )) {
      this.pageStateService.clear(this.learningPathsStateKey);
    }

    this.loadingService.load(
      this.learningPathService.getLearningPathsOverview()
    ).subscribe(learningPaths => {
      this.learningPaths = learningPaths;
    })
  }

  learningPathNavigateHandler(id?: string) {
    this.router.navigate([
      'manage-learning-path', id || 'new'
    ]);
  }

  learningPathNavigateHandlerNewTab(id?: string) {
    const url = this.router.serializeUrl(
      this.router.createUrlTree([
        'manage-learning-path', id
      ])
    );
    window.open(url, '_blank');
  }

  navigateToNewLearningPath() {
    this.router.navigate([
      'manage-learning-path', 'new'
    ]);
  }
}
